<template>
  <div id="attendancePage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="حضور و غیاب"></ActionBar>
    <!--        <div class="row container mx-auto p-0 mt-2">
              <div class="col-12 col-sm-10 col-md-6 col-lg-6 p-0 mb-4 mx-auto">
                <div class="member-ship-tab p-2 d-flex justify-space-between">
                  <v-btn :class="{active: dailyAttendance}" class="px-lg-16" color="third" rounded
                         @click="showDailyAttendance"><span class="font12px">حضور و غیاب روزانه</span>
                  </v-btn>
                  <v-btn :class="{active: classAttendance}" class=" px-lg-16" color="third" rounded
                         @click="showClassAttendance"><span class="font12px">حضور و غیاب درسی</span>
                  </v-btn>
                </div>
              </div>
            </div>
            <div v-if="dailyAttendance">-->
    <div class="row container mx-auto no-gutters p-0 mt-2">
      <div class="row">
<!--        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-left="100"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate1"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    color="forth"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date1"
                  color="forth"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker1"></v-date-picker>
            </v-menu>
          </div>
        </div>-->
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">تاریخ:</span></div>
          <div>
            <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-left="100"
                min-width="auto"
                offset-y
                transition="scale-transition">
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="inputDate2"
                    v-bind="attrs"
                    v-on="on"
                    append-icon="mdi-calendar"
                    class="input-border"
                    dense
                    hide-details
                    readonly
                    solo></v-text-field>
              </template>
              <v-date-picker
                  v-model="date2"
                  locale="fa-ir"
                  width="256"
                  @input="inputDatePicker2"></v-date-picker>
            </v-menu>
          </div>
        </div>
        <div class="col-6 col-md-4 col-lg-3">
          <div><i class="fas fa-chalkboard-teacher pl-1"></i><span class="font12px">کلاس:</span></div>
          <v-autocomplete
              v-model="classId"
              :items="classesItems"
              class="input-border"
              color="white"
              dense
              @change="test"
              item-text="Text"
              item-value="Value"
              solo></v-autocomplete>
        </div>
        <div class="col-6 col-md-4 col-lg-3  mx-auto">
          <v-btn block class="" color="primary" @click="searchAttendance">
            جستجو
          </v-btn>
        </div>
      </div>
      <div v-if="hasSearchResult" class="col-12 p-0">
        <div v-if="!hasData" class="col-12 p-0">
          <div class="row mx-2  knowledge-base-body">
            <div class="col-12">
              <v-alert
                  border="bottom"
                  class="mt-4 text-center"
                  color="forth"
                  dark>
                نتیجه ای یافت نشد
              </v-alert>
            </div>
          </div>
        </div>
        <div v-else class="col-12 p-0 rounded-b-lg header-rounded bg-white pb-4 card-shadow mt-4">
          <div class="third-background header-rounded mb-3 white--text p-2">حضور و غیاب روزانه دانش آموز</div>
          <div class="profile-field row mx-1">
            <div v-for="item in items" :key="item.CurrentLessonID"
                 class="light-gray-bottom-border col-12 col-md-4 col-sm-6 py-3"><span
                class="gray-color font10px ml-2">
            {{ $convertDate(item.ModifiedDate) }}</span>{{ dayOfWeek[$dayOfWeek(item.ModifiedDate)] }} - {{item.LessonsFunName}}<span
                class="float-left">
              <v-btn v-if="!item.StudentProfileID_IsPresences[studentID]" color="third" rounded small
                     @click="openAbsentReason(item.ModifiedDate,item.CurrentLessonID)"><span
                  class="font12px">علت غیبت</span>
                <i class="fas fa-long-arrow-left mr-1 pb-1"></i></v-btn>   <span v-else class="ml-8">حاضر</span></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    </div>-->
    <!--    <div v-if="classAttendance">
          <div class="row container mx-auto no-gutters p-0 mt-2">
            <div class="col-12  rounded-b-lg header-rounded bg-white card-shadow">
              <div class="third-background header-rounded mb-3 white&#45;&#45;text p-2">حضور و غیاب روزانه دانش آموز</div>
              <div class="profile-field row mx-1">
                <div v-for="item in classItems" :key="item.id"
                     class="light-gray-bottom-border col-12 col-md-4 col-sm-6"><span
                    class="gray-color font10px ml-1">{{ item.date }}</span>{{ item.day }}<span class="float-left">
                  <v-btn color="third"
                         rounded small @click="openAbsentReason(item.date ,item.day)"><span class="font12px">علت غیبت</span> <i
                      class="fas fa-long-arrow-left mr-1 pb-1"></i></v-btn></span></div>
              </div>
            </div>
          </div>
        </div>-->
    <v-dialog v-model="absentReason" max-width="500">
      <v-card class="text-right">
        <div class=" rounded-b-lg header-rounded bg-white card-shadow">
          <div class="third-background text-right header-rounded  white--text p-2">حضور و غیاب روزانه دانش آموز</div>
          <div class="bg-white">
            <div class="light-gray-bottom-border p-1">
              <i class="fas fa-calendar-check"></i>
              روز : <span class="gray-color font10px ml-1">{{ date }}</span>
            </div>
            <div class="light-gray-bottom-border p-2">
              <div>علت غیبت:</div>
              <v-textarea
                  v-model="absentDescription"
                  class="input-border"
                  dense
                  hide-details
                  solo
                  type="text">
              </v-textarea>
            </div>
            <div class="light-gray-bottom-border d-flex p-2">
              <v-file-input
                  id="ImageFileUrl"
                  class="input-border"
                  dense
                  hide-details
                  name="ImageFileUrl"
                  solo></v-file-input>
              <!--              <v-btn class="black mr-2" rounded><span class="white&#45;&#45;text"><span class="font12px">آپلود فایل </span><i-->
              <!--                  class="fas fa-download ml-2 pb-1"></i></span></v-btn>-->
            </div>
            <div class="text-center p-2">
              <v-btn class="gradient-btn px-6" rounded @click="registerAbsentReason">
                ثبت اطلاعات
              </v-btn>
            </div>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <FooterMenu/>
    <v-dialog
        v-model="showLoaderDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center py-5">
        <v-progress-circular
            color="primary"
            indeterminate
        ></v-progress-circular>
      </v-card>
    </v-dialog>
    <v-dialog
        v-model="showResultDialog"
        hide-overlay
        persistent
        width="500">
      <v-card class="text-center pt-5">
        <v-card-text class="pb-0">
          <div class="mb-0 black--text">{{ dialogResult }}</div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pt-1 pb-3">
          <v-btn block class="primary" rounded @click="showResultDialog = !showResultDialog">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
let _this = null
import ActionBar from "../components/ActionBar";
import FooterMenu from "../components/FooterMenu";
import moment from "moment-jalaali";

export default {
  name: "Attendance",
  metaInfo: {
    title: 'مسیربرتر-حضور و غیاب'
  },
  components: {FooterMenu, ActionBar},
  data: () => ({
    dailyAttendance: true,
    classAttendance: false,
    items: [],
    classItems: [
      {id: 1, date: '12 مرداد 1400', day: 'ریاضیات'},
      {id: 2, date: '8 مرداد 1400', day: 'فیزیک'},
      {id: 3, date: '18 مرداد 1400', day: 'زبان'},
    ],
    absentReason: false,
    date: null,
    day: null,
    inputDate1: '',
    inputDate2: '',
    menu1: false,
    menu2: false,
    date1: null,
    date2: null,
    classesItems: [],
    classId: null,
    studentID: null,
    showLoaderDialog: false,
    dayOfWeek: ['یکشنبه', 'دوشنبه', 'سه شنبه', 'چهار شنبه', 'پنج شنبه', 'جمعه', 'شنبه'],
    hasData: false,
    hasSearchResult: false,
    absentDescription: null,
    currentLessonID: null,
    showResultDialog: false,
    dialogResult: null,
    absentResultHistory: null,
    absentDate: null,
  }),
  mounted() {
    _this = this;
    this.getData()

  },
  methods: {

    test() {

    },
    /*    showDailyAttendance() {
          this.dailyAttendance = true;
          this.classAttendance = false;
        },
        showClassAttendance() {
          this.dailyAttendance = false;
          this.classAttendance = true;
        },*/
    getAbsentReasonHistory() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "AttendanceManagement/ListAbsensReason?StartDate=" + this.date2 + "&EndDate=" + this.date2, requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.absentResultHistory = JSON.parse(result)
          })
          .catch(error => console.log('error', error));
    },
    openAbsentReason(date, currentLessonID) {
      let absentHistory = this.absentResultHistory
      let find = absentHistory.filter(x => x.CurrentLessonID === currentLessonID && x.ModifiedDate === date)
      if (find.length > 0) {
        this.showResultDialog = true
        this.dialogResult = 'قبلا برای این روز علت غیبت ثبت کرده اید'
      } else {
        this.currentLessonID = currentLessonID
        this.date = this.$convertDate(date);
        this.absentDate = date
        this.absentReason = true
      }
    },
    inputDatePicker1() {
      this.menu1 = false
      this.inputDate1 = moment(this.date1).format('jYYYY/jMM/jDD')
    },
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },
    getData() {
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "AttendanceManagement/List", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)

            _this.studentID = json.StudentProfileID;
            _this.classesItems = json.ClassRooms;
            _this.inputDate1 = _this.$convertDate(json.StartDate)
            _this.date1 = _this.$convertDateToMiladi(_this.inputDate1)
            _this.inputDate2 = _this.$convertDate(json.EndDate)
            _this.date2 = _this.$convertDateToMiladi(_this.inputDate2)
            setTimeout(function () {
              _this.getAbsentReasonHistory()
            }, 200)

          })
          .catch(error => console.log('error', error));
    },
    searchAttendance() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StudentProfileID", _this.studentID);
      urlencoded.append("LessonsFunID", _this.classId);
      urlencoded.append("StartDate", _this.inputDate2);
      urlencoded.append("EndDate", _this.inputDate2);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      // let response = null
      fetch(this.$baseUrl + "AttendanceManagement/_List", requestOptions)
          .then(response => {
            return response.text()
          })
          .then(result => {

            let json = JSON.parse(result)
            if (json.StatusCode === 500) {
              _this.hasData = false
            } else {
              if (json.length === 0) {
                _this.hasData = false
              } else {

                console.log("SSSSSSSSS");
                console.log(this.classId);
                console.log(this.classId === null);
                console.log(json);

                if(this.classId === null){
                  _this.items = json;
                }else{
                  _this.items = json.filter(x => x.LessonsFunID === this.classId)
                }
                _this.hasData = true;

              }
            }
            _this.showLoaderDialog = false
            _this.hasSearchResult = true
          })
          .catch(error => console.log('error', error));
    },
    registerAbsentReason() {
      this.absentReason = false;
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", _this.$getUserData().token);

      let formdata = new FormData();
      formdata.append("CurrentLessonID", this.currentLessonID);
      formdata.append("Description", this.absentDescription);
      formdata.append("ModifiedDate", this.absentDate);
      formdata.append("ImageFileUrl", document.getElementById('ImageFileUrl').files[0]);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "AttendanceManagement/SetAbsensReason", requestOptions)
          .then(response => response.text())
          .then(result => {
            _this.showLoaderDialog = false;
            _this.dialogResult = result
            _this.showResultDialog = true
            _this.getAbsentReasonHistory()
            this.absentDescription = null
            document.getElementById('ImageFileUrl').files[0] = null
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>


